import { signOutRequest } from "@/store/auth/authSlice";
import { createContext, useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import io from "socket.io-client";
import { apiUrl } from "../config/apiUrl";
import { setUnReadNotificationCount } from "@/store/common/commonSlice";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const { isLogin, user, access_token } = useSelector(
    (state) => state.authReducer
  );
  const socketRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    socketRef.current = io(apiUrl, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0,
      auth: {
        token: `Bearer ${access_token}`,
      },
    });
    if (isLogin) {
      socketRef.current.emit("join", { id: user?._id });
    }

    return () => {
      socketRef.current?.disconnect();
    };
  }, [isLogin]);

  useEffect(() => {
    if (socketRef.current) {
      socketRef.current.on("new-notification", (data) => {
        if (user?.defaultState?._id === data?.state) {
          dispatch(setUnReadNotificationCount(data?.unreadCount));
        }
      });
      socketRef.current.on("user-deactivated", (userId) => {
        if (user?._id === userId?.receiverUser) {
          dispatch(signOutRequest());
        }
      });
      return () => {
        socketRef.current.off("new-notification");
        socketRef.current.off("user-deactivated");
      };
    }
  }, [socketRef.current]);
  return (
    <WebSocketContext.Provider value={socketRef}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
